import { createTheme } from "@mui/material/styles";

export default createTheme({
  typography: {
    fontFamily: ["Roboto", "Helevetica", "Arial", "roboto", "sans-serif", "altgencyFont"].join(","),
  },
  palette: {
    primary: {
      main: "#0C1F40",
      light: "rgba(53, 102, 160, .3)",
      dark: "rgba(0, 0, 0, 0.54)",
      contrastText: "#fff",
    },
    secondary: {
      main: "#B6B6C3",
      light: "#E8E8ED",
      dark: "rgba(0, 0, 0, 0.38)",
    },
    error: {
      main: "#CC2F41",
    },
    background: {
      default: "#F4F4FC",
    },
    success: {
      main: "#2E9890",
      light: "rgba(46, 152, 143, 0.75)",
    },
    info: {
      main: "#236FC9",
    },
  },
  components: {
    MuiTextField: {
      defaultProps: {
        size: "medium",
      },
    },
    MuiInputBase: {
      defaultProps: {
        size: "medium",
      },
      styleOverrides: {
        root: {
          fontSize: "0.875rem",
          color: "#142B52",
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true, // ✅ disables shadow on all buttons
        size: "small",
      },
      styleOverrides: {
        root: {
          textTransform: "none", // 👈 disables uppercase globally
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: "0.875rem",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: "0.875rem",
          color: "#142B52",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        body1: {
          fontSize: "0.875rem",
        },
        subtitle1: {
          fontSize: "0.875rem",
          fontWeight: "bold",
        },
      },
    },
  },
});
